import { MeshStandardMaterial, type Texture } from 'three';

const byColor = new Map<string, MeshStandardMaterial>();

/** Shared flat-colour materials so hundreds of boxes don't each allocate one. */
export function flatMaterial(color: string): MeshStandardMaterial {
  let material = byColor.get(color);
  if (!material) {
    // Matte by default: plaster, concrete, cloth. Glossy things set their own roughness.
    material = new MeshStandardMaterial({ color, roughness: 0.88, metalness: 0 });
    byColor.set(color, material);
  }
  return material;
}

export function texturedMaterial(map: Texture): MeshStandardMaterial {
  return new MeshStandardMaterial({ map });
}
